import React from "react";

const RadioGroup = ({ name, options, value, onChange }) => {
  return (
    <div className="radio-group flex space-x-4"> {/* Using flexbox to align horizontally */}
      {options.map((option) => (
        <label key={option} className="radio-label flex items-center"> {/* Flex on label to align input and text */}
          <input
            type="radio"
            name={name}
            value={option}
            checked={value === option}
            onChange={() => onChange(option)}
            className="mr-2"
          />
          {option}
        </label>
      ))}
    </div>
  );
};

export default RadioGroup;
